import { render, staticRenderFns } from "./viewProject.vue?vue&type=template&id=33b0b33d&"
import script from "./viewProject.vue?vue&type=script&lang=js&"
export * from "./viewProject.vue?vue&type=script&lang=js&"
import style0 from "./viewProject.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports